var React = require('react');

function PointsBgTriangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M162.906 113.311L83.1561 8.23037M162.906 113.311L88.3821 86.4648M162.906 113.311L28.68 101.423M83.1561 8.23037L88.3821 86.4648M83.1561 8.23037L28.68 101.423M88.3821 86.4648L28.68 101.423","stroke":"#553E6B"}));
}

PointsBgTriangle.defaultProps = {"width":"164","height":"171","viewBox":"0 0 164 171","fill":"none"};

module.exports = PointsBgTriangle;

PointsBgTriangle.default = PointsBgTriangle;
